import { useContext } from 'react'
import { SideSheetsHistoryContext } from '../context/SideSheetsHistoryContext'
import type { SideSheetsHistory } from '../typings/SideSheetsHistory'

export function useSideSheetsHistory(): SideSheetsHistory | undefined {
  return useContext(SideSheetsHistoryContext)
}
